export enum UserRoleTypes {
    WAITLIST_ADMIN = 'WaitListAdmin',
    SUPER_ADMIN = 'SuperAdmin',
}

